import { DOCS_URL } from "../../../config/constants.js";

export default {
    component: {
        load: () => import("./SlideDeck.svelte"),
    },
    name: "Slide Deck",
    description: "Render a PDF slide deck with custom Skywire controls.",
    docsLink: `${DOCS_URL}/storybook/?path=/docs/molecules-slidedeck--docs`,
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/presentation.svg",
    screenshot: "",
    inputs: [
        {
            friendlyName: "PDF file",
            name: "pdfFile",
            type: "file",
            allowedFileTypes: ["pdf"],
            required: true,
            helperText:
                "Upload a PDF exported from Google Slides. Link annotations in the PDF will be rendered as clickable areas.",
        },
        {
            friendlyName: "Accessible title",
            name: "title",
            type: "text",
            defaultValue: "Slide deck",
            helperText: "Used as the accessible label for the deck region.",
        },
        {
            friendlyName: "Tracking ID",
            name: "trackingId",
            type: "text",
            required: true,
            helperText:
                "Use a stable unique deck or campaign slug, for example jewellery-ecommerce-2026. GA4 receives event slide_deck_clicked; filter by tracking_id. Tracked action values are external_link, internal_link, and download. Supporting properties include deck_title, page_number, page_count, link_url, target_page, download_label, and page_path.",
        },
        {
            friendlyName: "Download label",
            name: "downloadLabel",
            type: "text",
            defaultValue: "Download deck",
        },
        {
            friendlyName: "Show download",
            name: "showDownload",
            type: "boolean",
            defaultValue: true,
        },
        {
            friendlyName: "Show fullscreen",
            name: "showFullscreen",
            type: "boolean",
            defaultValue: true,
        },
        {
            friendlyName: "Background Colour",
            name: "backgroundColour",
            type: "color",
            defaultValue: "#ffffff",
        },
    ],
};
